import fontFaceName from "./font-face-name";

const fontFace = (font) => `
@font-face {
  font-family: '${fontFaceName(font.name)}';
  src: url('${font.fontFile.url}') format('${font.fontFile.mimeType.replace("font/", "")}'),;
  font-weight: 300;
  font-style: normal;
  font-display: block;
}
`;

export default function injectFonts(data) {
  if (!data) return;

  const fontOptions =
    data.product.monogramSettings.fontOptions || data.globalConfig.defaultFonts;

  document.querySelector("data-monogram-fonts")?.remove();

  const style = document.createElement("style");
  style.dataset.monogramFonts = "";
  style.innerHTML = fontOptions.map((font) => fontFace(font)).join("\n");

  document.body.append(style);
}
